import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import  Typo  from '../Typo';

const Wrapper = styled.div`
  width:100%;
`;

const NoAccessPage = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Typo.ContentSmallHeader $textAlign='left'>{t('coursePage.noAccess.title')}</Typo.ContentSmallHeader>
      <Typo.Text>{t('coursePage.noAccess.description')}</Typo.Text>
      <Typo.Text>support@coursio.com</Typo.Text>
    </Wrapper>
  );
};

export default NoAccessPage;
